<template>
    <b-row no-gutters>
        <b-col sm="12" md="3">
            <h6 class="main-label">Points Multiplier</h6>
        </b-col>
        <b-col>
            <b-form-group id="pmBranch" class="mb-1">
                <label for="branches" class="secondary-label">Specify Branch?</label>
                <b-form-checkbox id="enableBranch"
                    v-model="values.enable_branch"
                    name="enableBranch"
                    class="secondary-label ml-3"
                    :disabled="values.multipliers.length > 1">
                    Yes
                </b-form-checkbox>
            </b-form-group>
            <div v-for="(multiplier, index) in values.multipliers"
                :key="'multiplier' + index">
                <b-row no-gutters>
                    <b-col>
                        <b-form-group
                            label="Branch"
                            label-for="branch"
                            label-class="secondary-label"
                            v-if="values.enable_branch"
                            :invalid-feedback="errorMessage('multiplier_settings.' + index + '.branch_uuid')"
                            :state="isValid('multiplier_settings.' + index + '.branch_uuid')">
                            <b-form-select
                                v-model="multiplier.branch"
                                :options="branches" class="muli-sb"
                                :disabled="values.enable_branch != true" />
                        </b-form-group>
                        <b-row no-gutters>
                            <b-col md="4">
                                <b-form-group
                                    label="Multiplier"
                                    label-for="multipler"
                                    label-class="secondary-label"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.multiplier')"
                                    :state="isValid('multiplier_settings.' + index + '.multiplier')">
                                    <b-form-input type="number"
                                        v-model="multiplier.multiplier"
                                        min="1">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-form-radio-group
                            v-model="multiplier.selected_option"
                            class="mb-2">
                            <b-form-radio value="day" class="secondary-label" selected>Day</b-form-radio>
                            <b-form-radio value="dateRange" class="secondary-label">Date Range</b-form-radio>
                        </b-form-radio-group>
                        <b-form-group v-if="multiplier.selected_option === 'day'"
                            label="Day(s)" label-for="days" label-class="secondary-label"
                            :invalid-feedback="errorMessage('multiplier_settings.' + index + '.range_days')"
                            :state="isValid('multiplier_settings.' + index + '.range_days')"
                            >
                            <b-form-checkbox-group id="daysGroup"
                                v-model="multiplier.days"
                                :options="values.days"
                                name="days"
                                buttons>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-row v-if="multiplier.selected_option === 'dateRange'">
                            <b-col>
                                <b-form-group
                                    label="Start Date"
                                    label-for="start_date"
                                    class="secondary-label mb-3 sl-helper"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.start_date')"
                                    :state="isValid('multiplier_settings.' + index + '.start_date')"
                                >
                                    <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                                        <b-input-group-text slot="append" class="bg-transparent">
                                            <img src="@/assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                                @click="openCalendar('start')">
                                        </b-input-group-text>
                                        <SingleDatepicker :bootstrap-styling="true"
                                            :value="multiplier.start_date"
                                            ref="datepicker_start"
                                            v-model="multiplier.start_date"
                                            wrapper-class="custom-datepicker"
                                            :style="{color: '#2a2a2a !important', width: index > 0 ? '124px' : '130px'}"
                                            :disabledDates="disabledDates"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="End Date"
                                    label-for="end_date"
                                    class="secondary-label mb-3 sl-helper"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.end_date')"
                                    :state="isValid('multiplier_settings.' + index + '.end_date')"
                                    >
                                    <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                                        <b-input-group-text slot="append" class="bg-transparent">
                                            <img src="@/assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                                @click="openCalendar('end')">
                                        </b-input-group-text>
                                        <SingleDatepicker :bootstrap-styling="true"
                                            :value="multiplier.end_date"
                                            ref="datepicker_end"
                                            v-model="multiplier.end_date"
                                            wrapper-class="custom-datepicker"
                                            :style="{color: '#2a2a2a !important', width: index > 0 ? '124px' : '130px'}"
                                            :disabledDates="disabledEndDates(index)"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-form-group class="mb-1">
                            <label for="time" class="secondary-label">Specify Time?</label>
                            <b-form-checkbox
                                v-model="multiplier.enable_time"
                                class="secondary-label ml-3">
                                Yes
                            </b-form-checkbox>
                        </b-form-group>
                        <b-row v-if="multiplier.enable_time">
                            <b-col>
                                <b-form-group
                                    label="Start Time"
                                    label-for="start_time"
                                    class="secondary-label mb-3 sl-helper"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.start_time')"
                                    :state="isValid('multiplier_settings.' + index + '.start_time')">
                                    <div style="width: 164px;">
                                        <b-input-group>
                                            <b-input-group-text slot="append" class="bg-transparent">
                                                <img src="@/assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                            </b-input-group-text>
                                            <vue-timepicker
                                                format="HH:mm"
                                                hide-clear-button
                                                v-model="multiplier.start_time">
                                            </vue-timepicker>
                                        </b-input-group>
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="End Time"
                                    label-for="end"
                                    class="secondary-label mb-3 sl-helper"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.end_time')"
                                    :state="isValid('multiplier_settings.' + index + '.end_time')"
                                >
                                    <div style="width: 164px;">
                                        <b-input-group>
                                            <b-input-group-text slot="append" class="bg-transparent">
                                                <img src="@/assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                            </b-input-group-text>
                                            <vue-timepicker
                                                format="HH:mm"
                                                hide-clear-button
                                                v-model="multiplier.end_time">
                                            </vue-timepicker>
                                        </b-input-group>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-form-group class="mb-1">
                            <label for="time" class="secondary-label">Specify Frequency?</label>
                            <b-form-checkbox
                                v-model="multiplier.enable_frequency"
                                name="enableFrequency"
                                class="secondary-label ml-3">
                                Yes
                            </b-form-checkbox>
                        </b-form-group>
                        <b-row v-if="multiplier.enable_frequency">
                            <b-col>
                                <b-form-group
                                    label="Frequency"
                                    label-for="frequency"
                                    label-class="secondary-label"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.frequency')"
                                    :state="isValid('multiplier_settings.' + index + '.frequency')">
                                    <b-form-input type="number"
                                        v-model="multiplier.frequency"
                                        :formatter="frequencyFormatter"
                                        min="1">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    label="Frequency Range"
                                    label-for="frequency_range"
                                    label-class="secondary-label"
                                    :invalid-feedback="errorMessage('multiplier_settings.' + index + '.frequency_range')"
                                    :state="isValid('multiplier_settings.' + index + '.frequency_range')">
                                    <b-form-select v-model="multiplier.frequency_range"
                                        :options="values.frequencies">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="1" v-if="index > 0" class="text-right">
                        <b-button variant="ghost btn-remove shadow-none"
                            @click="deleteMultiplier(index)">
                        </b-button>
                    </b-col>
                </b-row>
                <b-row v-if="values.multipliers.length > 1">
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
            </div>
            <b-row v-if="values.enable_branch">
                <b-col>
                    <b-form-group>
                        <b-button variant="ghost" class="shadow-none px-0"
                            @click="addMultiplier"
                            :disabled="values.multipliers.length == branches.length - 1">
                            <img src="@/assets/images/icons/add.svg" class="action-button" alt="Add Icon">
                            <span class="text-primary ml-2">Add Branch</span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";

export default {
    name: "PointsMultiplier",
    props: ["values"],
    components: {
        SingleDatepicker,
        VueTimepicker
    },
    computed: {
        ...mapState("achievements", ["points_multiplier", "errors"]),
    },
    data() {
        return {
            branches: [
                { value: null, text: "Select Branch", disabled: true }
            ],
            disabledDates: {
                to: new Date(Date.now() - 864e5)
            }
        }
    },
    created: function() {
        if (this.values.enable_branch) {
            this.getBranches();
        }
    },
    methods: {
        openCalendar: function(type) {
            let calendar = "datepicker_" + type;
            this.$refs[calendar][0].showCalendar();
        },

        addMultiplier: function() {
            this.$emit("addMultiplier");
        },

        deleteMultiplier: function(index) {
            this.$emit("deleteMultiplier", index);
        },

        getBranches: async function() {
            this.branches = [
                { value: null, text: "Select Branch", disabled: true }
            ];
            await this.$store.dispatch("achievements/getBranches");
        },

        disabledEndDates: function(index) {
            return  {
                to: new Date(this.values.multipliers[index].start_date - 8640000)
            };
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },

        frequencyFormatter(value, event) {
            return event === null
                ? value
                : value.replace(/\./gi, "").substring(0, 4);
        },
    },
    watch: {
        "values.enable_branch": function(status) {
            if (status === true) {
                this.getBranches();
            }
        },
        "points_multiplier.branches": function(branches) {
            branches.map((branch) => {
                this.branches.push(branch);
            });
        }
    }
};
</script>
